export type HockeyPlayerId = 1 | 2 | 3 | 4 | 5 | 6;
export const hockeyPlayerIdNumbers: HockeyPlayerId[] = [1, 2, 3, 4, 5]; // does not include 6 (goalie)
export type HockeyPlayerLabelType = "FD" | "LR";
